module.exports = __webpack_public_path__ + "static/media/id-selfie.feae6837.png";